import { SpeakerListMeetingResponse } from './../../models/speakerModel/speaker-list-meeting-response';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SpeakerCountryResponseModel } from 'src/app/models/speakerModel/SpeakerCountryResponseModel';
import { userResponse } from 'src/app/models/userModel/userResponse';

@Injectable({
  providedIn: 'root'
})
export class SpeakerService {

  private base = environment.urlServerApi;

  constructor(private _http: HttpClient) {
   }

  getCountryName(): Observable<SpeakerCountryResponseModel>{
    return this._http.get<SpeakerCountryResponseModel>(`${this.base}country`)
  }

  getCountriesMeeting(meetingId:number): Observable<SpeakerCountryResponseModel>{
    return this._http.get<SpeakerCountryResponseModel>(`${this.base}meetings/country?meetingId=${meetingId}`,
    { headers: new HttpHeaders({'Access-Control-Allow-Origin':'*'})})
  }

  getSpeakerByMeeting(meetingId:number): Observable<SpeakerListMeetingResponse>{
    return this._http.get<SpeakerListMeetingResponse>(`${this.base}meetings/speakers?meetingId=${meetingId}`,
    { headers: new HttpHeaders({'Access-Control-Allow-Origin':'*'})})
  }

  getUserMeet(idMeet:number): Observable<userResponse>{
    return this._http.get<userResponse>(`${this.base}meetings/users?idMeeting=${idMeet}`)
  }

  getUserAdv(idTrans:number): Observable<userResponse>{
    return this._http.get<userResponse>(`${this.base}transcriptions/users?idTranscription=${idTrans}`)
  }
}
